module.exports = __webpack_public_path__ + "static/img/join_bg.aa255ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join_bg.png
// module id = KxTu
// module chunks = 0